import Yup from 'utils/validation';
import { Tone } from 'generated-graphql/types';

export const conversationSettingsSchema = Yup.object().shape({
  successfulMessage: Yup.string().required('Successful message is required'),
  unsuccessfulMessage: Yup.string().required(
    'Unsuccessful message is required'
  ),
  notInterestedMessage: Yup.string().required(
    'Not interested message is required'
  ),
  agentName: Yup.string().required('Agent name is required'),
  agentTone: Yup.string()
    .oneOf(Object.values(Tone))
    .required('Agent tone is required')
});

export type ConversationSettingsFormData = {
  successfulMessage: string;
  unsuccessfulMessage: string;
  notInterestedMessage: string;
  agentName: string;
  agentTone: Tone;
};
